import { z } from 'zod';
/**
 * IDs stored in TenantUser.dismissedOnboardingCards — one per dismissible Overview card,
 * plus ONBOARDING_WIZARD, a visibility marker (not a card) that suppresses the wizard's
 * one-time automatic post-setup redirect once a user has skipped or finished it. Never
 * render ONBOARDING_WIZARD as a card in OverviewPage's OnboardingCards().
 *
 * BUSINESS_DETAILS, TAX_SETTINGS, BRANDING and PAYMENT_DETAILS no longer have a card (the
 * onboarding wizard replaced them) but must stay: existing users have them stored, and
 * OnboardingCardIdSchema validates the stored list on read, so removing one would fail
 * the onboarding status request for those users.
 */
export const ONBOARDING_CARD = {
    BUSINESS_DETAILS: 'business-details',
    TAX_SETTINGS: 'tax-settings',
    BRANDING: 'branding',
    PAYMENT_DETAILS: 'payment-details',
    GETTING_STARTED: 'getting-started',
    TWO_FACTOR_SECURITY: 'two-factor-security',
    ONBOARDING_WIZARD: 'onboarding-wizard',
};
export const OnboardingCardIdSchema = z.enum(Object.values(ONBOARDING_CARD));
//# sourceMappingURL=onboarding-cards.js.map